module.exports = __webpack_public_path__ + "img/icon_home_supreme_top.89d1e09c.png";